import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {Container} from "@mui/material";

const FillScreenLayout =({children, position = 'center'}) => {
    const capitalizeFirstLetter = (string) =>
        string.charAt(0).toUpperCase() + string.slice(1);

    return (
        <Container maxWidth="md" className="fillScreenLayout">
            <div className={"h-100"}>
                <div className={"flexColumn" + capitalizeFirstLetter(position) + " h-100"}>
                    {children}
                </div>
            </div>
        </Container>
        );
}

export default compose(
    withTranslation()
)(FillScreenLayout)